import PublicationRecord from "models/view-models/publication-record";
import React, { useEffect } from "react";
import useBookviewTableOfContents from "utilities/hooks/domain/publications/use-bookview-table-of-contents";
import useVirtualTableOfContents from "./use-virtual-table-of-contents";
import NotebookBookviewDisplay from "./notebook-bookview-display";
import NotebookReferencePanelTableOfContents from "pages/notebooks/notebook-reference-panel/bookview/table-of-contents/notebook-reference-panel-table-of-contents";

const BASE_CLASS_NAME = "c-notebook-reference-panel-bookview";
interface NotebookReferencePanelBookviewProps {
    publication: PublicationRecord;
}
const NotebookReferencePanelBookview = (
    props: NotebookReferencePanelBookviewProps
) => {
    const { publication } = props;
    const { getTableOfContents } = useBookviewTableOfContents();
    const { currentTocItem } = useVirtualTableOfContents();
    const displayBookview = !!currentTocItem;
    useEffect(() => {
        if (publication.id != null) {
            getTableOfContents(publication.id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [publication.id]);

    return (
        <div className={BASE_CLASS_NAME}>
            {!displayBookview && (
                <NotebookReferencePanelTableOfContents
                    publication={publication}
                />
            )}
            {displayBookview && <NotebookBookviewDisplay />}
        </div>
    );
};

export default NotebookReferencePanelBookview;
